export default __webpack_public_path__ + "static/media/BusinessBoxImage-min.dee6e9dd.png";